<template>
    <div class="w-full mt-6 xxs:px-2 xxs:py-0 lg:py-2 flex items-center bg-semitone-primary-1/50 rounded flex-wrap">
        <div class="flex items-center justify-center cursor-pointer text-body-6 xxs:mt-2 lg:mt-0 xxs:mb-2 lg:mb-0">
            <Popper content="Use this breadcrumbs section to navigate through nested folders">
                <div class="w-4 h-4 mr-3 rounded-full bg-default-1/80 flex items-center justify-center text-white text-body-7">i</div>
            </Popper>
            <FolderIcon class="w-5 h-5 mr-2 flex-shrink-0"  :color="color.hex" />
            <span class="text-default-1 xxs:text-body-6 mlg:text-body-5 whitespace-nowrap" @click="navigateTo('all_files', 0)">All files</span>
        </div>
        <div
            class="flex items-center justify-center flex-shrink-0 xxs:mt-2 lg:mt-0 xxs:mb-2 lg:mb-0"
            v-for="(folder, index) in breadcrumbs"
        >
            <img src="@/assets/icons/chevron-right.svg" alt="Chevron right" class="w-3 h-3 ml-2 mr-2" />
            <div
                class="xxs:text-body-6 mlg:text-body-5 cursor-pointer max-w-[100px] overflow-hidden whitespace-nowrap overflow-ellipsis"
                :class="[index === currentFolderIndex ? 'text-primary-1' : 'text-default-1']"
                @click="navigateTo(folder, index)"
            >
                {{ folder.documentable.title }}
            </div>
        </div>

    </div>
</template>

<script setup>
import {computed} from "vue";
import FolderIcon from '@/components/icons/small/Documents/Folder.vue';
import {useTheme} from "@/stores/ThemeStore";
import Popper from "vue3-popper";
const {color} = useTheme();

const props = defineProps({
    breadcrumbs: {
        type: Array,
        default: () => [],
    }
});

const emit = defineEmits(['navigate']);

const currentFolderIndex = computed(() => {
    if(props.breadcrumbs.length === 0) {
        return 0;
    }

    return props.breadcrumbs.length - 1
})

function navigateTo(folder, index) {
    if(currentFolderIndex.value >= 1 && index === currentFolderIndex.value) {
        return;
    }

    if(typeof folder === 'string') {
        emit('navigate', folder);
        return;
    }

    if(['file', 'document'].includes(folder.documentable_type)) {
        return;
    }

    emit('navigate', folder.documentable.uid);
}
</script>

<style>
:root {
    --popper-theme-background-color: #3D4252;
    --popper-theme-text-color: #ffffff;
    --popper-theme-text-size: 12px;
    --popper-theme-background-color-hover: #3D4252;
    --popper-theme-border-width: 0px;
    --popper-theme-border-style: solid;
    --popper-theme-border-radius: 6px;
    --popper-theme-padding: 8px;
    --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
    --popper-z-index: 100;
}

</style>